import {
    from,
    of,
} from 'rxjs';
import {
    switchMap,
    retry,
    catchError,
    filter,
} from 'rxjs/operators';

import callService from './callService';
import {
    RETRY_COUNT_API_SERVICE_DEFAULT,
} from '../../Errors/Constants/Error.retries';

const createServiceResponseStream = (
    serviceUrl,
    serviceRequest,
    serviceProxy,
    requestData,
    handleServiceError,
    retries = RETRY_COUNT_API_SERVICE_DEFAULT,
) =>
    of(requestData)
        .pipe(
            switchMap(data =>
                from(
                    callService(
                        serviceUrl,
                        serviceRequest,
                        serviceProxy,
                        data,
                    )
                )
            ),
            retry(retries),
            catchError(error => {
                handleServiceError(error);
                return of(void 0);
            }),
            filter(Boolean),
        );

export default createServiceResponseStream;
